import { render } from "./category-add-list.vue?vue&type=template&id=8c1ff960&scoped=true"
import script from "./category-add-list.vue?vue&type=script&lang=js"
export * from "./category-add-list.vue?vue&type=script&lang=js"

import "./category-add-list.vue?vue&type=style&index=0&id=8c1ff960&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1ff960"]])

export default __exports__